import { SET_DICOM_RECORD } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface DicomRecord {
    dicom_p_id: string;
    first_name: string;
    last_name: string;
    dob: string;
    accession_number: string;
    study_date: string;
    description: string;
    modality: string;
    referring_physician: string;
    instances: string;
}

export default (p_oid: string, request: DicomRecord): Promise<Response> => {
    return fetchWithRefresh(SET_DICOM_RECORD(p_oid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
